export default __webpack_public_path__ + "static/trustedIcon5-a468661e32205bd68250f06d74731c33.png";